import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "relative w-full h-full p-5 bg-white border border-darkgray-900/[.04] rounded-2xl cursor-pointer" }
const _hoisted_2 = {
  key: 0,
  class: "w-3 h-3 rounded-full block absolute right-4 top-4 bg-[#C20000]"
}
const _hoisted_3 = { class: "mb-1 font-bold text-primary-500" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "line-clamp-1 overflow-hidden text-ellipsis"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 1,
  class: "mb-1 text-darkgray-900"
}
const _hoisted_8 = { class: "text-darkgray-900" }
const _hoisted_9 = { class: "text-darkgray-900" }
const _hoisted_10 = {
  key: 2,
  class: "text-darkgray-400 italic"
}

import { format, parse } from 'date-fns'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppointmentCard',
  props: {
    item: {
        type: Object,
        required: true
    },
    badge : {
        default: false,
        type: Boolean
    }
},
  setup(__props) {

const props = __props;

// const isUpcoming = computed(() => {
//     const givenDate = new Date(props.item.booking_date);
//     const today = new Date();
    
//     // Calculate the difference in milliseconds between the two dates
//     const differenceInMilliseconds = givenDate.getTime() - today.getTime();
//     // Calculate the difference in days by dividing the milliseconds by the number of milliseconds in a day (24 * 60 * 60 * 1000)
//     const differenceInDays = Math.floor(differenceInMilliseconds / (24 * 60 * 60 * 1000));

//     if (differenceInDays === 3) {
//         return true;
//     } else {
//         return false;
//     }
// })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.badge)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_3, [
      (__props.item.package_name)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.item.package_name), 1))
        : (__props.item.riders)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Selected Procedures Only"))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, "TBA"))
    ]),
    (__props.item.booking_type == 'Corporate' || __props.item.booking_type == 'Soft')
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.item.booking_type == 'Corporate'
                ? (__props.item.corporate_name ?? 'TBA') 
                : 'Soft Booking') + " ", 1))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_8, [
      _createTextVNode(_toDisplayString(__props.item.booking_date ? _unref(format)(new Date(__props.item.booking_date ), 'EEE, MMM dd yyyy') : _unref(format)(new Date(), 'EEE, MMM dd, yyyy')) + " ", 1),
      _createElementVNode("span", _hoisted_9, " | " + _toDisplayString(__props.item.booking_start_time ? new Date(__props.item.booking_start_time).toLocaleTimeString([], { timeZone: 'UTC', hour: '2-digit', minute:'2-digit' }) : 'TBA') + " - " + _toDisplayString(__props.item.booking_end_time ? new Date(__props.item.booking_end_time).toLocaleTimeString([], { timeZone: 'UTC', hour: '2-digit', minute:'2-digit' }) : 'TBA'), 1)
    ]),
    (__props.item.booking_type == 'Dependent')
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, " For Dependent "))
      : _createCommentVNode("", true)
  ]))
}
}

})